<template>
  <div class="page">
    <van-dialog id="van-dialog" />
    <van-action-sheet
      v-model="acShow"
      :actions="[{name:'删除',color:'#ee0a24'},{name:'多选'},{name:'清空',color:'#ee0a24'}]"
      @select="onAsSelect"
      @cancel="onAsClose"
    />
    <van-calendar v-model="dateShow" @confirm="onDateConfirm" position="top" :min-date="minDate" :max-date="maxDate"/>
    <div class="notice" style="color: #32abdf">
      <van-row>
        <van-col span="8"><span  @click="dateShow = true">{{date}}</span></van-col>
        <van-col span="8">{{ balanceDesc }}</van-col>
        <van-col span="8"><span @click="goRenewal">立即购买</span></van-col>
      </van-row>
    </div>
<!--    <div class="notice" v-if="newDataCount">-->
<!--      <van-notice-bar color="#07C160" @close="nbClose" @click="nbClick" mode="closeable" :text="newDataCount +' 条新数据'" />-->
<!--    </div>-->
    <div class="loading" v-if="loading">
      <van-loading type="spinner" />
    </div>
    <div class="scroll-container" ref="scrollContainer">
      <div class="scroll-content" @scroll="handleScroll" ref="scrollContent">
        <van-empty v-if="!loading && !list.length" description="暂无数据" />
        <div @click="loadNextPage" class="more" v-if="!loading">
          <span v-if="loadAll && query.number !== 1">已加载全部数据</span>
        </div>
        <div v-for="(item,i) in reverseList" :key="`${item.id}_${i}`" :id="'item_' + item.id" class="item">
<!--          <van-divider v-if="i!== 0 && i % query.size===0" contentPosition="center"></van-divider>-->
          <div class="time">{{item.createTimeStr || dateFormat(item)}}</div>
          <div class="content">
            <div v-if="selectModel" class="checkbox">
              <van-checkbox :name="item.id" v-model="item.checked"></van-checkbox>
            </div>
            <div class="avatar">
              <van-image fit="fill" width="30" height="30" :src="item.deviceAvatar" />
            </div>
            <div class="triangle"></div>
            <div class="player"
                 @touchstart="itemTouchstart(item)"
                 @touchend="itemTouchend"
                 @touchmove="itemTouchmove"
                 @click="audioPlay(item,i)">
              <van-loading type="spinner" v-if="playId===item.id && loadingAudio"/>
              <div v-else class="icon">
                <van-icon size="20px" :name="playId===item.id?icon.sonicGif:icon.sonic" />
              </div>
              <div class="duration">{{item.duration}}″</div>
            </div>
            <div v-if="!item.read" class="tip"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div v-if="selectModel" class="select">
        <div class="left">
          <van-button @click="selectAll" size="mini" type="primary">全选</van-button>
          <van-button @click="reverseSelect" plain size="mini" type="primary">反选</van-button>
        </div>
        <div class="right">
          <van-button @click="delSelect" type="danger" icon="delete">删除</van-button>
          <van-button @click="exitSelect" icon="close" plain type="danger">退出</van-button>
        </div>
      </div>
      <div v-else class="audio">
        <div style="width: 100%;text-align: left">
          <div style="color: red;font-size: 15px">温馨提示免责声明:</div>
          <div style="color: #323233;font-size: 12px">安防语聊功能适用于儿童，老人关爱监护及车辆等贵重物品的防丢防盗措施，用户自愿启动安防拾音功能包括自愿购买增值服务项目，内容不可以传播，不可以用于违法行为。如非法使用导致任何的法律责任均由使用者承担责任，请用户谨慎使用。</div>
        </div>
        <div style="width: 100%">
          <van-popover
              style="width: 100%"
              placement="top"
              v-model="showPopover"
              trigger="click"
              :actions="audioModels"
              @select="onAudioModelSelect"
          >
            <template #reference>
              <van-button type="info" round block>{{audioModelText}}</van-button>
            </template>
          </van-popover>
        </div>

<!--        <div class="text">点击拾音</div>-->
<!--        <div @click="refresh">-->
<!--          <van-icon :name="icon.audio" size="50px" />-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {ICON} from "@/global/constants";
import {readCommonParam} from "@/util/session-storage-utils";
import {getToken} from "@/util/auth";
import {audioClean, audioDel, audioPage, deviceAudioRecordReq, getAudioBalanceInfo, getAudioModel} from "@/api/audio";
import service from "@/util/request";
import {
  ActionSheet,
  Button,
  Checkbox,
  Dialog,
  Divider,
  Empty,
  Icon,
  Image as VanImage,
  Loading,
  NoticeBar,
  Toast,
    Col,
    Row,
    Cell,
  Calendar,
  Popover
} from 'vant';
import moment from "moment";
import {updateInfo} from "@/api/device";

export default {
  name: "index",
  components: {
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
    [NoticeBar.name]: NoticeBar,
    [Empty.name]: Empty,
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    [VanImage.name]: VanImage,
    [Button.name]: Button,
    [Loading.name]: Loading,
    [Col.name]: Col,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [Calendar.name]: Calendar,
    [Popover.name]: Popover,
    [Dialog.Component.name]: Dialog.Component
  },
  created(){

    document.title = this.$t("语聊记录");
    // this.loadData();

  },
  mounted() {
    readCommonParam(this)
    // 获取窗口高度
    this.clientHeight = window.innerHeight;
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);

    // 初始化数据
    if (this.$route.query._imei) {
      this.imei = this.$route.query._imei;
      this.initData();
      this.loadData();
      getAudioModel(this.imei).then((resp) => {
        if (resp && resp.code === 0) {
            this.audioModel = resp.data
        }
      })


    }

    // 检查滚动容器
    this.$nextTick(() => {
      const container = this.$refs.scrollContainer;
      const content = this.$refs.scrollContent;
      if (container && content) {

        // 添加滚动事件监听
        content.addEventListener('scroll', this.handleScroll);

        // 滚动到底部
        this.scrollToBottom();
      }
    });
    setInterval(()=>{
        let query = this.query
        query.imei = this.$route.query._imei
        this.audioPage({...query,number:1},true)
        this.getAudioBalanceInfo(query.imei)
      }
      ,3000
  )
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    const content = this.$refs.scrollContent;
    if (content) {
      content.removeEventListener('scroll', this.handleScroll);
    }
    if (this.ac != null) {
      this.ac.stop();
      this.ac = null;
    }
    this.initData();
  },
  data(){
    return {
      baseURL: service.defaults.baseURL,
      query:{
        size:20,
        number:1,
        imei:null,
        startTime:null,
        endTime:null,
      },
      balanceDesc:"",
      minDate:moment("1990-01-01",'YYYY-MM-DD').toDate(),
      maxDate:moment().toDate(),
      date:moment().format('YYYY-MM-DD'),
      dateShow:false,
      list: [],
      audioModel:0,
      loading: true,
      loadingAudio: false,
      loadAll:false,
      clientHeight:0,
      icon:ICON,
      playId:null,
      ac:null,
      newDataCount:0,
      scrollIntoView:null,
      scrollId:null,
      scrollTop:false,
      acShow:false,
      touch:false,
      selectModel:false,
      touchItemId:null,
      deviceAvatarMap:{},
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      audioModels: [{value:1, text: '声控拾音' }, { value:2,text: '持续拾音' }, { value:0,text: '关闭拾音' }, { value:null,text: '取消' }],
    }
  },
  computed:{
    listHeight(){
      let height = this.clientHeight - this.acHeight;
      if(this.newDataCount>0){
        height -= 40;
      }
      return height
    },
    audioModelText(){
      if(this.audioModel !== null){
        for (const i in this.audioModels) {
          let am =  this.audioModels[i];
          if(am.value === this.audioModel){
            return am.text
          }
        }

      }
      return "";
    },
    acHeight(){
      return this.selectModel?80:110
    },
    reverseList(){
      return [...this.list].reverse();
    }
  },
  watch:{
    scrollId(id){
      if(id == null){
        return
      }
      let that = this;
      setTimeout(() => {
        that.scrollIntoView = "item_" + id
      },200)

    },
    scrollTop(val){
      if(val){
        this.newDataCount=0
      }
    }
  },

  methods:{
    initData(){
      this.query={
        size:20,
          number:1,
          imei:null,
      };
      this.list=[];
      this.loading=true;
      this.loadingAudio=false;
      this.loadAll=false;
      this.clientHeight=0;
      this.playId=null;
      this.ac=null;
      this.newDataCount=0;
      this.scrollIntoView=null;
      this.scrollId=null;
      this.scrollTop=false;
      this.acShow=false;
      this.touch=false;
      this.selectModel=false;
      this.touchItemId=null;
      this.deviceAvatarMap={}
    },
    onAudioModelSelect(action) {
      if(action.value != null){
        updateInfo({imei:this.imei,voiceAudioValue:action.value}).then(resp => {
          if(resp.code === 0){
            Toast("操作成功")
            this.audioModel = action.value;
          }

        });
      }

    },
    handleScroll(e) {
      const target = e.target;
      const scrollTop = target.scrollTop;

      // 滚动到顶部200px时加载更多
      if (scrollTop <= 100 && !this.loading && !this.loadAll) {
        window.console.log('触发加载更多，当前滚动位置:', scrollTop);
        this.loadNextPage();
      }
    },
    goRenewal(){
      // getCurrentDeviceImei(imei => navigateToRenewal(imei))
      window.location.href = "/pay/index?_imei="  + this.imei + "&type=" + 8
      // getCurrentDeviceImei(imei => window.location.href = "/pay/index?_imei="  + imei + "&type=" + 8)

    },
    handleResize() {
      this.clientHeight = window.innerHeight;
    },
    dateFormat(item){
      item.createTimeStr = this.$formatDate(new Date(item.createTime))
    },
    loadData(){
      let imei = this.imei;
      let query = this.query;
      query.imei = imei
      query.keyword = imei
      this.query = query
      this.audioPage(query);
      this.getAudioBalanceInfo(imei)
    },
    async getAudioBalanceInfo(imei){
      await getAudioBalanceInfo(imei).then(resp => {
        const data = resp.data;
        this.balanceDesc = data.balanceDesc
      })

    },
    onDateConfirm(date) {
      this.dateShow = false;
      this.date = this.formatDate(date);
      this.query.number = 1
      this.loadData()
    },
    formatDate(date) {

      return moment(date).format('YYYY-MM-DD');
    },
    async audioPage(query,checkNew){
      this.loading = !checkNew ;
      try {
        let time = moment(this.date,'YYYY-MM-DD');
        query.startTime = time.format('YYYY-MM-DD HH:mm:ss');
        query.endTime = time.add(1, 'd').format('YYYY-MM-DD HH:mm:ss');
        audioPage(query).then(resp => {
          const data = resp.data;
          for (const i in data.dataList) {
            let item = data.dataList[i];
            item.checked = false;
            this.deviceAvatarMap[item.imei] = item.deviceAvatar;
          }
          // 使用 Map 来确保数据唯一性
          const existingIds = new Set(this.list.map(item => item.id));
          const newDataList = data.dataList.filter(item => !existingIds.has(item.id));
          if(query.number === 1 && !checkNew){
            this.list = newDataList;
          }else{
            // 将新数据添加到列表头部
            if(newDataList.length > 0){
              if(checkNew){
                this.list = newDataList.concat(this.list);
              }else{
                this.list = this.list.concat(newDataList);
              }
            }
            if(!checkNew){
              this.loadAll = data.dataList.length < this.query.size;
            }
          }

          if(newDataList.length > 0){
            if(query.number === 1){
              let that = this;
              this.scrollTop = false;
              if(checkNew && !this.isBottom()){
                //
                return
              }
              setTimeout(() => {
                that.scrollToBottom();
              }, 200);
            }
          }
        });

      } catch (error) {
        window.console.error('加载数据失败:', error);
      } finally {
        this.loading = false;
      }
    },
    async refresh(){
      const loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      try {
        const resp  = await deviceAudioRecordReq({imei:this.imei})
        if(resp.code){
          return Toast({
            message: resp.msg,
            duration: 3000
          })
        }
        return Toast({
          message: "指令已下发，请等待设备上传数据",
          duration: 3000
        })
      } catch (e) {
        window.console.error('刷新数据失败:', e);
        Toast({
          message: '刷新失败，请稍后重试',
          duration: 3000
        });
      } finally {
        loading.clear();
      }
    },
    itemTouchmove(){
      this.touch = false
    },
    itemTouchstart(item){
      if(this.selectModel){
        //多选模式,不响应
        return;
      }
      this.touch = true
      let that = this;
      setTimeout(() => {
        if(that.touch){
          that.touch = false
          that.touchItemId = item.id
          that.acShow=true
        }
      },500)
    },
    itemTouchend(){
      this.touch = false
    },
    audioPlay(item, index) {
      if (this.acShow) {
        // 长按事件
        return;
      } else if (this.selectModel) {
        // 多选模式,单击时不播放
        item.checked = !item.checked;
        return;
      }

      let id = item.id;
      if (this.playId === id) {
        // 再次点击,停止播放
        this.playId = null;
        this.loadingAudio = false;
        if (this.ac) {
          this.ac.pause();
        }
        return;
      }

      this.loadingAudio = true;
      const url = this.baseURL + 'device/audioRecord/down/mp3/' + id + "?token=" + getToken();
      window.console.log('正在加载音频:', url);

      if (!this.ac) {
        this.ac = new Audio();
      } else {
        this.ac.pause();
      }

      this.ac.src = url;
      this.playId = id;

      this.ac.onplay = () => {
        window.console.log('音频开始播放');
      };

      this.ac.onended = () => {
        window.console.log('音频播放结束');
        this.playId = null;
        const nextIndex = index + 1;
        if (nextIndex < this.reverseList.length && !this.reverseList[nextIndex].read) {
          // 还有下一个未读录音,继续播放
          this.audioPlay(this.reverseList[nextIndex], nextIndex);
        }
      };

      this.ac.onerror = (e) => {
        window.console.error('音频加载失败:', e);
        this.loadingAudio = false;
        this.playId = null;
        Toast({
          message: '音频加载失败，请稍后重试',
          duration: 3000
        });
      };

      this.ac.ontimeupdate = () => {
        if (this.loadingAudio) {
          this.loadingAudio = false;
          item.read = true;
        }
      };

      this.ac.play().catch(err => {
        window.console.error('播放音频失败:', err);
        this.loadingAudio = false;
        this.playId = null;
        Toast({
          message: '音频播放失败，请稍后重试',
          duration: 3000
        });
      });
    },
    loadNextPage(){
      if(this.loadAll || this.loading){
        window.console.log('跳过加载: loadAll=', this.loadAll, 'loading=', this.loading);
        return;
      }
      window.console.log('开始加载第', this.query.number + 1, '页');
      let query = this.query;
      query.number++;
      this.query = query;
      this.audioPage(query);
    },
    nbClose(){
      this.newDataCount=0
    },
    nbClick(){
      this.newDataCount=0
      this.scrollId =  this.list[0].id
      this.scrollTop = true
    },
    ready(){

    },
    onAsSelect(e){
      this.acShow = false
      let name = e.name
      if("多选" === name){
        this.selectModel = true;
        this.newDataCount=0
      }else if("下载地址" === name){
        this.download(this.touchItemId)
      }else if("删除"===name){
        this.doDel([this.touchItemId])
      }else if("清空" === name){
        this.doClean()
      }
    },
    download(id) {
      const url = this.baseURL + 'device/audioRecord/down/mp3/' + id + "?token=" + getToken();
      navigator.clipboard.writeText(url).then(() => {
        Dialog.alert({
          title: '下载提示',
          message: '下载地址已复制到剪贴板，请在浏览器中打开下载',
          theme: 'round-button',
        });
      }).catch(err => {
        window.console.error('复制到剪贴板失败:', err);
      });
    },
    onAsClose(){
      this.acShow = false
    },
    checkboxChange(item,val){
      item.checked = val
    },
    selectAll(){
      let list = this.list;
      for (const i in list) {
        list[i].checked = true
        if(i > 500){
          Toast({
            message: "批量选择不能超过500项",
            duration: 3000
          })
          return
        }
      }
    },
    reverseSelect(){
      let list = this.list;
      let checkedCount = 0
      for (const i in list) {
        let item = list[i]
        item.checked = !item.checked
        if(item.checked){
          checkedCount +=1
        }
        if(checkedCount > 500){
          Toast({
            message: "批量选择不能超过500项",
            duration: 3000
          })
          return
        }
      }
    },
    exitSelect(){
      this.selectModel=false
      let list = this.list;
      for (const i in list) {
        list[i].checked = false
      }
    },
    delSelect(){
      let idList = []
      for (const i in this.list) {
        let item = this.list[i]
        if(item && item.id  && item.checked){
          idList.push(item.id)
        }

      }
      if(idList.length === 0){
        Toast({
          message: "请选中数据",
          duration: 3000
        })
        return
      }
      this.doDel(idList)
    },
    doDel(idList){
      if(!idList || !idList.length){
        return
      }
      let title
      if(idList.length > 1){
        title = '确认删除当前选中的 '+ idList.length + ' 项数据?'
      }else{
        title = "确认删除当前数据?"
      }
      Dialog.confirm({
        title: title,
        message:"删除后不可恢复",
      }).then(async () => {
        try{
          const loading = Toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
          });
          await audioDel({str:idList.join()})
          loading.close();
          this.list = this.list.filter((value) => {
            return !idList.includes(value.id)
          });
          // eslint-disable-next-line no-empty
        }catch (e){
          window.console.error('删除数据失败:', e);
        }
      })
        .catch(() => {
          // on cancel
        });
    },
    doClean(){
      Dialog.confirm({
        title: "确认清空当前设备数据",
        message:"执行后不可恢复",
      }).then(async () => {
        // on confirm
        try {
          const loading = Toast.loading({
            message: '处理中...',
            forbidClick: true,
          });
          await audioClean(this.imei)
          loading.close();
          this.list = []
          // eslint-disable-next-line no-empty
        }catch (e){
          window.console.error('清空数据失败:', e);
        }
      })
        .catch(() => {
          // on cancel
        });
    },
    websocketMsgHandle(resp){
      if(!resp){
        return
      }
      if(resp.action !== "AUDIO"){
        return;
      }
      let imei = resp.imei
      if(imei !== this.imei){
        return;
      }
      let audio = resp.data
      audio.checked = false
      audio.read = false
      audio.createTime = audio.time
      audio.deviceAvatar = this.deviceAvatarMap[imei];
      this.list.splice(0,0,audio)
      if(this.scrollTop){
        //已在底部,滚动到新数据
        this.scrollId = audio.id
      }else{
        this.newDataCount +=1
      }

    },
    isBottom(){
      const content = this.$refs.scrollContent;
      window.console.info("isBottom ",content.scrollTop,content.scrollHeight)
      return content && content.scrollTop === content.scrollHeight;
    },
    scrollToBottom() {
      const content = this.$refs.scrollContent;
      if (content) {
        // 使用 setTimeout 确保在 DOM 更新后执行
        setTimeout(() => {
          content.scrollTop = content.scrollHeight;
        }, 100);
      }
    },
  },
}
</script>

<style scoped>
.page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #F7F8FA;
  display: flex;
  flex-direction: column;
}

.notice {
  flex-shrink: 0;
  text-align: center;
  padding-top: 10px;
  font-size: 16px;
}

.loading {
  flex-shrink: 0;
  text-align: center;
  padding: 20px 0;
}

.scroll-container {
  flex: 1;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
  margin-bottom: 170px;
}

.scroll-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 15px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  transform: translateZ(0);
  will-change: transform;
  background-color: #f2f3f5;
}

.more {
  text-align: center;
  font-size: 16px;
  padding: 10px 0;
}

.item {
  padding: 8px 0;
}

.time {
  width: 100%;
  text-align: center;
  font-size: 10px;
  color: #C8C9CC;
}

.content {
  font-size: 16px;
  display: flex;
  align-items: center;
}

.checkbox {
  margin-right: 5px;
}

.avatar {
  margin-top: 4px;
}

.triangle {
  width: 0;
  height: 0;
  border-right: 5px solid #ffffff;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  margin-left: 5px;
}

.player {
  background-color: #ffffff;
  width: 60%;
  height: 30px;
  display: flex;
  align-items: center;
  position: relative;
}

.icon {
  margin: 4px 5px 0px 5px;
}

.duration {
  margin-left: 5px;
}

.tip {
  margin-left: 5px;
  background: rgba(250,60,0,1);
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 140px;
  background-color: #ffffff;
  padding: 10px;
  z-index: 1;
}

.select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.left {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.right {
  display: flex;
  gap: 10px;
}

.audio {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.text {
  font-size: 12px;
  margin-bottom: 10px;
}
</style>
